import Furniture from './Furniture';
import Heart from 'app/campout/Heart';
// import { NIGHT_TINT } from 'app/constants/AppConstants.js';

export default class Bin extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.isBin = true;
    this.type = this.data.type;
    this.dropArea = this.data.drop_area;
  }

  createAsset() {
    this.asset = this.game.make.image(0, 0, this.data.key, this.id);
    this.asset.anchor.set(0.5, 1);

    this.addChild(this.asset);
  }

  setLight(power) {
    this.setLight2(power);
  }

  updateTint(tween, value, tweenData) {
    super.updateTint(tween, value, tweenData);

    this.asset.tint = this.tintColor;
  }

  canPutItemIntoBin(item) {
    // slot is empty
    if (this.visible) {
      const bb1 = new Phaser.Rectangle(this.bb.x, this.bb.y, this.dropArea.w, this.dropArea.h);
      const bb2 = item.bb;
      if (Phaser.Rectangle.intersects(bb1, bb2)) {
        return true;
      }
    }

    return false;
  }

  putItemIntoBin(item) {
    // anim
    this.game.add
      .tween(this.scale)
      .to({ x: [1.1, 0.9, 1], y: [0.9, 1.1, 1] }, 500, Phaser.Easing.Quadratic.Out, true);

    if (this.type === 'recycle' && item.isRecyclable()) {
      // positive feedback
      const heart = new Heart(this.game, 0, -this.asset.height);
      this.addChild(heart);
    }

    if (item.canBeTrashed()) {
      item.trashed = true;
      item.disable();
      item.x = 0;
      item.y = -this.height;
      this.addChild(item);

      this.location.removeItem(item);
    } else {
      item.alpha = 0;
      this.game.time.events.add(500, this.throwOutItem, this, item);
    }

    //
    this.game.sounds.playSFX('item_bin', { spriteID: 'sfx' });

    //
    this.location.state.setLoopHint(this.data.hint);
  }

  pulse(time = 1500) {
    this.game.add
      .tween(this.asset.scale)
      .to({ x: [1.2, 1, 1.2, 1, 1.2, 1], y: [1.2, 1, 1.2, 1, 1.2, 1] }, time, null, true);
  }

  throwOutItem(item) {
    this.game.add
      .tween(this.scale)
      .to({ x: [1.1, 0.9, 1], y: [0.9, 1.1, 1] }, 500, Phaser.Easing.Quadratic.Out, true);
    this.game.time.events.add(250, this.throwOutItem2, this, item);
  }

  throwOutItem2(item) {
    item.visible = true;
    item.alpha = 1;
    item.throwOutTo(this.x, this.y - this.height + 10);
  }
}
